import { DateUtils } from '../../utils';
import { LocationHotelsSuppliers } from '../../models';

const hasValidGeoId = (destination) => Boolean(destination?.id);

const isSupportedDestination = (destination) => {
    const hasContent = Boolean(destination && Object.keys(destination).length > 0);
    if (!hasContent) {
        return false;
    }

    const isFromHotelsSupplier = destination.geoNodeIdSupplier === LocationHotelsSuppliers.HSA;
    return isFromHotelsSupplier ? hasValidGeoId(destination) : true;
};

export const isValidAccommodationSearch = (currentAccommodationSearch) => {
    const hasDestination = isSupportedDestination(currentAccommodationSearch?.destination);
    const hasValidDates = Boolean(DateUtils.isValidDate(DateUtils.parse(currentAccommodationSearch?.dates?.checkin)) &&
        DateUtils.parse(currentAccommodationSearch?.dates?.checkout));
    const hasRooms = Boolean(Array.isArray(currentAccommodationSearch?.rooms) && currentAccommodationSearch.rooms.length > 0);

    return hasDestination && hasValidDates && hasRooms;
};
